import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TODO: define this
interface ActivationState {
  [key: string]: any;
}

const activationSlice = createSlice({
  name: 'activation',
  initialState: null as ActivationState | null,
  reducers: {
    updateActivation: (
      state,
      action: PayloadAction<Partial<ActivationState>>
    ) => {
      if (state === null) {
        return { ...action.payload };
      }
      return { ...state, ...action.payload };
    },
    clearActivation: () => {
      return null;
    },
  },
});

export const { updateActivation, clearActivation } = activationSlice.actions;
export default activationSlice.reducer;
